module.exports = __webpack_public_path__ + "9fd1fcbfedb5ace0e6e61a88b3fc3402.svg";